import { RouteComponentProps } from 'react-router'
import { makeStyles } from '@material-ui/core/styles'

import { HeightTrackerContextWrapper } from '@scoir/college-details'
import { HeightObserverContextWrapper } from '@scoir/height-observer'

import AdmissionsHeaderNavigation from 'components/HeaderNavigation'
import Snackbar from 'components/Snackbar'

const useStyles = makeStyles((theme) => {
  return {
    inAppLayout: {
      position: 'relative',
      // @ts-expect-error - scoir theme override
      backgroundColor: theme.palette.pageBackground.main,
    },
    mainWrapper: {
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
    },
    mainContent: {
      overflow: 'auto',
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
    },
  }
})

interface InAppLayoutProps extends RouteComponentProps {
  children: React.ReactNode
}

const InAppLayout = ({ children, location, history }: InAppLayoutProps) => {
  const classes = useStyles()
  return (
    <HeightTrackerContextWrapper>
      <HeightObserverContextWrapper>
        <div className={classes.inAppLayout}>
          <div className={classes.mainWrapper}>
            <nav>
              <AdmissionsHeaderNavigation
                location={location}
                history={history}
              />
            </nav>
            <main
              id="app-main-content"
              className={classes.mainContent}
            >
              {children}
            </main>
          </div>
          <Snackbar />
        </div>
      </HeightObserverContextWrapper>
    </HeightTrackerContextWrapper>
  )
}

export default InAppLayout
